import _classCallCheck from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/* eslint-env browser */

/**
 * Isomorphic variable storage.
 *
 * Uses LocalStorage in the browser and falls back to in-memory storage.
 *
 * @module storage
 */

/* c8 ignore start */
var VarStoragePolyfill =
/*#__PURE__*/
function () {
  function VarStoragePolyfill() {
    _classCallCheck(this, VarStoragePolyfill);

    this.map = new Map();
  }
  /**
   * @param {string} key
   * @param {any} newValue
   */


  _createClass(VarStoragePolyfill, [{
    key: "setItem",
    value: function setItem(key, newValue) {
      this.map.set(key, newValue);
    }
    /**
     * @param {string} key
     */

  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.map.get(key);
    }
  }]);

  return VarStoragePolyfill;
}();
/* c8 ignore stop */

/**
 * @type {any}
 */


var _localStorage = new VarStoragePolyfill();

var usePolyfill = true;
/* c8 ignore start */

try {
  // if the same-origin rule is violated, accessing localStorage might thrown an error
  if (typeof localStorage !== 'undefined') {
    _localStorage = localStorage;
    usePolyfill = false;
  }
} catch (e) {}
/* c8 ignore stop */

/**
 * This is basically localStorage in browser, or a polyfill in nodejs
 */

/* c8 ignore next */


export var varStorage = _localStorage;
/**
 * A polyfill for `addEventListener('storage', event => {..})` that does nothing if the polyfill is being used.
 *
 * @param {function({ key: string, newValue: string, oldValue: string }): void} eventHandler
 * @function
 */

/* c8 ignore next */

export var onChange = function onChange(eventHandler) {
  return usePolyfill || addEventListener('storage',
  /** @type {any} */
  eventHandler);
};
/**
 * A polyfill for `removeEventListener('storage', event => {..})` that does nothing if the polyfill is being used.
 *
 * @param {function({ key: string, newValue: string, oldValue: string }): void} eventHandler
 * @function
 */

/* c8 ignore next */

export var offChange = function offChange(eventHandler) {
  return usePolyfill || removeEventListener('storage',
  /** @type {any} */
  eventHandler);
};